import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { operlogDetail } from "@/services/logService.js";
import { useTranslation } from "react-i18next";
import { Grid, CircularProgress, Alert } from "@mui/material";
import RightViewLayout from "@/components/RighViewLayout";
import { REACT_OPERATION_LOG } from "@/router/ReactEndPoints";
import ViewBox from "@/components/ViewBox";

function OperationDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [operLogDetail, setOperLogDetail] = useState({});
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOperationDetail = async () => {
      if (!state?.id) {
        setError(t("common.no_data"));
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const res = await operlogDetail(state.id);
        console.log("Operation detail response:", res);

        if (res?.data?.code === "LVLI0000") {
          setOperLogDetail(res.data?.data);
        } else {
          setError(t("common.no_data"));
        }
      } catch (err) {
        console.error("Error fetching operation detail:", err);
        setError(t("common.fail"));
      } finally {
        setLoading(false);
      }
    };

    fetchOperationDetail();
  }, [state?.id, t]);

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "-";
    try {
      return new Date(dateTime).toLocaleString();
    } catch (error) {
      return dateTime;
    }
  };

  const getStatusText = (status) => {
    if (status === 1) {
      return t("common.success");
    } else if (status === 0) {
      return t("common.fail");
    } else if (status === 2) {
      return t("common.in_query");
    }
    return "-";
  };

  if (loading) {
    return (
      <RightViewLayout
        title={t("operation_log.preview_title")}
        navigateBack={REACT_OPERATION_LOG}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "400px" }}>
          <CircularProgress />
        </Grid>
      </RightViewLayout>
    );
  }

  if (error) {
    return (
      <RightViewLayout
        title={t("operation_log.preview_title")}
        navigateBack={REACT_OPERATION_LOG}>
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      </RightViewLayout>
    );
  }

  return (
    <RightViewLayout
      title={t("operation_log.preview_title")}
      navigateBack={REACT_OPERATION_LOG}>
      <Grid container flexDirection={"column"} pl={6} pt={2}>
        <ViewBox
          title={t("operation_log.user_name")}
          content={operLogDetail?.userName || operLogDetail?.name}
        />

        <ViewBox
          title={t("operation_log.operation_method")}
          content={
            operLogDetail?.method
              ? t(`operation_log.${operLogDetail.method}`) ||
                operLogDetail.method
              : "-"
          }
        />

        <ViewBox
          title={t("operation_log.operation_time")}
          content={formatDateTime(operLogDetail?.operTime)}
        />

        <ViewBox
          title={t("operation_log.operation_ipaddr")}
          content={operLogDetail?.ipAddr}
        />

        <ViewBox
          title={t("operation_log.address")}
          content={operLogDetail?.location}
        />

        <ViewBox
          title={t("operation_log.operation_status")}
          content={getStatusText(operLogDetail?.status)}
        />

        <ViewBox
          title={t("operation_log.browser")}
          content={operLogDetail?.browser}
        />

        <ViewBox
          title={t("operation_log.system")}
          content={operLogDetail?.os}
        />
      </Grid>
    </RightViewLayout>
  );
}

export default OperationDetail;
